import Vue from 'vue';
import Router from 'vue-router';
const _import = require('./_import_' + process.env.NODE_ENV);
// in development env not use Lazy Loading,because Lazy Loading large page will cause webpack hot update too slow.so only in production use Lazy Loading

/* layout */
import Layout from '../views/layout/Layout';

/* login */
const Login = _import('login/login');
const ForcePassSet = _import('login/passSet');

const PassSet = _import('components/userSet/passReset');

/* dashboard */
const dashboard = _import('dashboard/index');

/* error page */
const Err404 = _import('404');


/* 系统设置 */

const MdelMent = _import('pgment/modelMent');
const UserMent = _import('pgment/userMent');
const RoleMent = _import('pgment/roleMent');
const DictMent = _import('pgment/dictMent');
const SectMent = _import('pgment/sectMent');
const ConnectMent = _import('pgment/orgConnect');
const UserFill = _import('pgment/register/userFill');
const UserReview = _import('pgment/register/userReview');
const SuccessFill = _import('pgment/register/successFill');
const UserReviewList = _import('pgment/register/userReviewList');
const PassReset = _import('pgment/register/passReset');
const UserRegister = _import('pgment/register/userRegister');
const RuleColumn = _import('pgment/rule/list/index');
const AddRuleColumn = _import('pgment/rule/add/index');

/* 产业信息 */

// const Isty_Statistics = _import('industryInfos/statistics/index');
// const Isty_Building_Infos = _import('industryInfos/buildingInfos/index');
// const Isty_Building_Edit = _import('industryInfos/buildingEdit/index');

// const Isty_Building_Get = _import('industryInfos/buildingManage/index');
// const Isty_Building_Ver = _import('industryInfos/buildingVerificate/index');

// const Isty_View = _import('industryInfos/buildingsView/index');
// const User_View = _import('industryInfos/userView/index');

// const Jx_Verificate = _import('industryInfos/buildingVerificate/jx');

/* cms */
const Column = _import('cms/column/list/index');
const AddColumn = _import('cms/column/add/index');
/* article */
const Publish = _import('cms/article/article_publish/list/index'); //发布文章列表
const Addpublish = _import('cms/article/article_publish/add/index'); // 新建文章内容
const inspectArticle = _import('cms/article/article_examine/add/index'); // 新建内容

const Examine = _import('cms/article/article_examine/list/index');

const ProfessionalCommitteeList = _import('cms/user/professional_committee/list/index'); // 专业委员会列表
const AddProfessionalCommittee = _import('cms/user/professional_committee/add/index'); // 新增专业委员会
const LawyerLibraryList = _import('cms/user/lawyer_library/list/index'); // 律师库列表
const AddLawyerLibrary = _import('cms/user/lawyer_library/add/index'); // 新增律师库
const TeamLibraryList = _import('cms/user/team_library/list/index'); // 团队库列表
const AddTeamLibrary = _import('cms/user/team_library/add/index'); // 新增团队库
const LawyerMessage = _import('cms/message/lawyer_message/list/index'); // 律师消息
const TeamMessage = _import('cms/message/team_message/list/index'); // 团队消息
const PlatformMessage = _import('cms/message/platform_message/list/index'); // 平台消息

const UserCenter = _import('cms/user/user_center/index'); // 新增专业委员会

// Vue.use(Router);


/**
 * icon : the icon show in the sidebar
 * hidden : if `hidden:true` will not show in the sidebar
 * redirect : if `redirect:noredirect` will not redirct in the levelbar
 * noDropdown : if `noDropdown:true` will not has submenu in the sidebar
 * meta : `{ role: ['admin'] }`  will control the page role
 **/
export const constantRouterMap = [
    { path: '/login', component: Login, hidden: true },
    { path: '/404', component: Err404, hidden: true },
    { path: '/paddSet', component: ForcePassSet, hidden: true },
    { path: '/register', component: UserFill, hidden: true },
    { path: '/userRegister', component: UserRegister, hidden: true },
    { path: '/success_register', component: SuccessFill, hidden: true },
    { path: '/pass_reset', component: PassReset, hidden: true },
    {
        path: '/',
        component: Layout,
        redirect: '/dashboard',
        name: 'Home',
        hidden: true,
        children: [{ path: 'dashboard', component: dashboard }]
    },
    // { path: '/cms_form', component: cms_form, hidden: true },
]

export default new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
});

// key必须对应数据库中的key否则不能注册路由
export const registerComponentMap = [{
        key: 'column',
        parent: true,
        noDropdown: true,
        component: Layout,
        childrenComponent: Column,
        children: [{
            key: 'add_column',
            parent: false,
            component: AddColumn
        }]
    },
    {
        key: 'cms',
        component: Layout,
        parent: true,
        children: [{
                key: 'cms_publish',
                parent: false,
                component: Publish
            },
            {
                key: 'add_publish',
                parent: false,
                component: Addpublish
            },
            {
                key: 'cms_examine',
                parent: false,
                component: Examine
            },
            {
                key: 'inspect_article',
                parent: false,
                component: inspectArticle
            },
        ]
    },
    {
        key: 'cms_user',
        component: Layout,
        parent: true,
        children: [{
                key: 'professional_committee_list',
                parent: false,
                component: ProfessionalCommitteeList
            },
            {
                key: 'add_professional_committee',
                parent: false,
                component: AddProfessionalCommittee
            },
            {
                key: 'team_library_list',
                parent: false,
                component: TeamLibraryList
            },
            {
                key: 'add_team_library',
                parent: false,
                component: AddTeamLibrary
            },
            {
                key: 'lawyer_library_list',
                parent: false,
                component: LawyerLibraryList
            },
            {
                key: 'add_lawyer_library',
                parent: false,
                component: AddLawyerLibrary
            },
        ]
    },
    {
        key: 'cms_message',
        component: Layout,
        parent: true,
        children: [{
                key: 'platform_message',
                parent: false,
                component: PlatformMessage
            },
            {
                key: 'team_message',
                parent: false,
                component: TeamMessage
            },
            {
                key: 'lawyer_message',
                parent: false,
                component: LawyerMessage
            },
        ]
    },
    {
        key: 'ss_ment',
        component: Layout,
        parent: true,
        children: [{
                key: 'sect_ment',
                parent: false,
                component: SectMent
            }, {
                key: 'user_ment',
                parent: false,
                component: UserMent
            },
            // {
            //     key: 'role_ment',
            //     parent: false,
            //     component: RoleMent
            // }, 
            {
                key: 'rule_column',
                parent: false,
                component: RuleColumn
            }, {
                key: 'rule_column_add',
                parent: false,
                component: AddRuleColumn
            }, {
                key: 'dict_ment',
                parent: false,
                component: DictMent
            }, {
                key: 'model_ment',
                parent: false,
                component: MdelMent
            },
            // {
            //     key: 'user_review',
            //     parent: false,
            //     component: UserReview
            // }, 
            // {
            //     key: 'user_review_list',
            //     parent: false,
            //     component: UserReviewList
            // }
        ]
    },
    { key: 'user_center', parent: true, noDropdown: true, component: Layout, childrenComponent: UserCenter },
    { key: 'pass_set', parent: true, noDropdown: true, component: Layout, childrenComponent: PassSet },
    // { key: 'add_column', noDropdown: true, component: Layout, childrenComponent: AddColumn },


];


// WEBPACK FOOTER //
// ./src/router/index.js